<template>
  <div>
    <el-row style="margin-top: 20px">
      <el-form :model="firstForm" ref="firstForm" :inline="true">
        <el-form-item label="客户：">
          <el-select size="medium" filterable v-model="firstForm.TC_ID" placeholder="请选择" @change="queryProject">
            <el-option v-for="item in companys" :key="item.ID" :label="item.AB_NAME" :value="item.ID"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目点：">
          <el-select size="medium" filterable v-model="firstForm.PROJECT_ID" placeholder="请选择" @change="queryDK">
            <el-option v-for="item in projects" :key="item.ID" :label="item.NAME" :value="item.ID"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="档口：">
          <el-select size="medium" filterable v-model="firstForm.DK_ID" placeholder="请选择">
            <el-option v-for="item in dkList" :key="item.ID" :label="item.NAME" :value="item.ID"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="送货时间：">
          <el-date-picker size="medium" v-model="firstForm.SEND_DATE" type="date" value-format="yyyy-MM-dd"
            placeholder="请选择" :clearable="false">
          </el-date-picker>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row>
      <el-button size="medium" @click="addProduct" :disabled="disabledFirstForm">添加出库产品</el-button>
    </el-row>
    <el-row>
      <el-table ref="listData" :data="listData" style="width: 100%; margin-top: 20px;" border>
        <el-table-column type="index" label="序号" width="50"></el-table-column>
        <el-table-column prop="PRODUCT_CODE" label="产品编码" min-width="80"></el-table-column>
        <el-table-column prop="PRODUCT_NAME" label="产品名称" min-width="80"></el-table-column>
        <el-table-column prop="TYPE_UNIT" label="单位" min-width="70"></el-table-column>
        <el-table-column prop="BATCH" label="批次"></el-table-column>
        <el-table-column prop="LOCATION_CODE" label="库位" v-if="WAREHOUSE_MODE == 2"></el-table-column>
        <el-table-column prop="PRODUCT_PRICE" label="库存价格" min-width="70"></el-table-column>
        <el-table-column prop="PRODUCT_COUNT" label="剩余库存数量" min-width="70"></el-table-column>
        <el-table-column prop="COUNT" label="出库数量" width="200">
          <template slot-scope="scope">
            <el-input v-model="scope.row.COUNT" placeholder="请输入" @change="checkCount(scope.row)" clearable></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="PRICE" label="销售价">
          <template slot-scope="scope">
            <el-input v-model="scope.row.PRICE" placeholder="请输入" @change="checkPrice" clearable></el-input>
          </template></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button size="small" type="text" @click="deleteProduct(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row>
      <el-col :span="2" :offset="22" style="margin-top: 24px;">
        <el-button size="small" type="default" @click="allSubmit" :disabled="disabledSubmit">添加完成</el-button>
      </el-col>
    </el-row>
    <!-- 添加出库产品模态框 -->
    <el-dialog title="添加出库产品" :visible.sync="addFormVisible" center width="1000px" @close="closeDialog"
      :close-on-click-modal="false">
      <el-row>
        <el-col>
          <el-form size="small" :inline="true" class="demo-form-inline" style="padding: 0; margin: 0">
            <el-form-item label="产品名称：">
              <el-input v-model="addForm.PRODUCT_NAME" @keyup.enter.native="handleSearch" clearable></el-input>
            </el-form-item>
            <el-form-item label="产品编码：">
              <el-input v-model="addForm.PRODUCT_CODE" @keyup.enter.native="handleSearch" clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-button size="small" type="primary" @click="handleSearch">筛选</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-table :data="tableData" stripe border style="width: 100%;margin-top: 10px">
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column prop="PRODUCT_CODE" label="产品编码" min-width="80"></el-table-column>
            <el-table-column prop="PRODUCT_NAME" label="产品名称" min-width="80"></el-table-column>
            <el-table-column prop="BATCH" label="批次" min-width="80"></el-table-column>
            <el-table-column prop="LOCATION_CODE" label="库位" v-if="WAREHOUSE_MODE == 2"></el-table-column>
            <el-table-column prop="PRODUCT_COUNT" label="库存" min-width="80"></el-table-column>
            <el-table-column prop="TYPE_UNIT" label="单位" min-width="80"></el-table-column>
            <el-table-column prop="PRODUCT_PRICE" label="单价" min-width="80"></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button size="small" type="text" @click="submitAddProduct(scope.row)"
                  :disabled="disabledAdd(scope.row)">添加</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <div class="pagination_box" style="text-align: left; margin-top: 20px; float: right;">
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
          layout="total,prev, pager, next, jumper" :total="totalCount"></el-pagination>
      </div>
      <div slot="footer" class="dialog-footer" style="float: none; margin-top: 20px">
        <el-button size="small" @click="closeDialog">完成</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { manualOutStockFun, queryWarehouseFun } from 'api/warehouseManager';
import { getEnteyCusFun, selectDKFun, selectProjectFun } from '@/assets/api/sellOrder';
import validation from '@/assets/common/validation';

export default {
  data () {
    return {
      firstForm: {},
      companys: [],
      projects: [],
      dkList: [],
      listData: [],
      WAREHOUSE_MODE: sessionStorage.getItem('WAREHOUSE_MODE'),
      addFormVisible: false,
      addForm: {},
      tableData: [],
      totalCount: 0,
      // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
      pageSize: Number(localStorage.getItem('SMP_PAGE_COUNT')) || 10,
      currentPage: 1,
      regCount: /^(([1-9]\d*)|(0{1}))(.\d+)?$/,
      regPrice: /^([1-9]\d*)(.\d{1,2})?$|^0.\d{1,2}$/,
    };
  },
  computed: {
    // 客户/项目/档口/送货时间是否已选齐
    disabledFirstForm () {
      return !this.firstForm.TC_ID || !this.firstForm.PROJECT_ID || !this.firstForm.DK_ID || !this.firstForm.SEND_DATE;
    },
    disabledSubmit () {
      return Boolean(
        this.disabledFirstForm
        || !this.listData.length
        || this.listData.find((item) => !item.COUNT
          || !item.PRICE
          || !this.regCount.test(item.COUNT)
          // || !this.regPrice.test(item.PRICE)
          || !validation.价格正数0验证(item.PRICE)
          || (this.$util.JudgmentUnit(item.TYPE_UNIT) ? true : Number(item.COUNT)) % 1
          || Number(item.COUNT) > Number(item.PRODUCT_COUNT)),
      );
    },
  },
  inject: ['reload'],
  created () {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    this.queryCustomer();
  },
  methods: {
    // 获取客户列表
    queryCustomer () {
      getEnteyCusFun().then((result) => {
        if (result.length !== 0) {
          this.companys = result;
        } else {
          this.companys = [];
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 获取项目点列表
    queryProject () {
      const params = {
        TC_ID: this.firstForm.TC_ID,
      };
      selectProjectFun(params).then((result) => {
        if (result[0]) {
          this.projects = result[0].list;
        } else {
          this.projects = [];
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 获取档口列表
    queryDK () {
      const params = {
        PROJECT_ID: this.firstForm.PROJECT_ID,
        STATUS: 1,
      };
      selectDKFun(params).then((res) => {
        this.dkList = res;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 检查输入数量
    checkCount (row) {
      if (!this.regCount.test(row.COUNT)) {
        this.$message.show({ text: '请输入正确的数量', type: 'warning' });
        return false;
      }
      if (!this.$util.JudgmentUnit(row.TYPE_UNIT)) {
        if (Number(row.COUNT) % 1) {
          this.$message.show({ text: '请输入正整数的数量', type: 'warning' });
          return false;
        }
      }
      if (Number(row.COUNT) > Number(row.PRODUCT_COUNT)) {
        this.$message.show({ text: '出库数量不得大于库存数量', type: 'warning' });
        return false;
      }
    },
    // 检查输入销售价
    checkPrice (value) {
      // if (!this.regCount.test(value)) {
      //   this.$message.show({ text: '请输入正确的价格', type: 'warning' });
      //   return false;
      // }
      if (!validation.价格正数0验证(value)) {
        this.$message.show({ text: '请输入正确的价格', type: 'warning' });
        return false;
      }
    },
    // 删除商品
    deleteProduct (row) {
      this.listData = this.listData.filter((item) => item.ID != row.ID);
    },
    // 添加商品
    addProduct () {
      this.addFormVisible = true;
    },
    // 筛选
    handleSearch () {
      this.queryProduct(1);
    },
    // 分页
    handleCurrentChange () {
      this.queryProduct(this.currentPage);
    },
    // 查询库存
    queryProduct (e) {
      const params = {
        TC_ID: this.firstForm.TC_ID,
        PAGESIZE: this.pageSize,
        PAGEINDEX: e - 1,
        SHOW: 0,
        FLAG: 0,
      };
      if (!this.addForm.PRODUCT_NAME && !this.addForm.PRODUCT_CODE) {
        this.$message.show({ text: '请输入产品名称或编码后筛选', type: 'warning' });
        return false;
      }
      if (this.addForm.PRODUCT_NAME) {
        params.PRODUCT_NAME = this.addForm.PRODUCT_NAME;
      }
      if (this.addForm.PRODUCT_CODE) {
        params.PRODUCT_CODE = this.addForm.PRODUCT_CODE;
      }
      queryWarehouseFun(params).then((result) => {
        this.totalCount = result[0].TOTAL_COUNT;
        this.tableData = result[0].OP_ROLE;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 添加商品限制
    disabledAdd (row) {
      return Boolean(this.listData.find((item) => item.ID == row.ID));
    },
    // 增加一条新的数据
    submitAddProduct (row) {
      this.listData.push({ ...row });
    },
    // 关闭模态框
    closeDialog () {
      this.addFormVisible = false;
      this.addForm = {};
      this.tableData = [];
      this.totalCount = 0;
    },
    // 添加完成
    allSubmit () {
      const tmpArr = this.listData.map((item, index) => ({
        PRODUCT_CODE: item.PRODUCT_CODE,
        PRODUCT_COUNT: item.COUNT,
        REAL_PRICE: item.PRICE,
        TYPE_UNIT: item.TYPE_UNIT,
        BATCH: item.BATCH,
        LOCATION_ID: Number(item.LOCATION_ID) ? Number(item.LOCATION_ID) : 0,
      }));
      const params = {
        DK_ID: this.firstForm.DK_ID,
        SEND_DAY: this.firstForm.SEND_DATE,
        WAREHOUSE_MODE: sessionStorage.getItem('WAREHOUSE_MODE'),
        LIST: tmpArr,
      };
      manualOutStockFun(params).then((result) => {
        this.$message.show({ text: '出库成功', type: 'success' });
        this.$router.push({ name: 'stockOut' });
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
  },
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/warehouseManage/manualStockOut.vue